<script lang="ts" setup>
import { computed } from 'vue';
import { TableContentProperty, UniqueHeaderKey } from '../../interface/tableContentHeaders';
import { TableContentItem } from '../../interface/tableContentItems';
import TableCell from '../TableCell.vue';
import { UniqueTableContentViewModel } from './uniqueTableContentViewModel';

// props
const props = withDefaults(
  defineProps<{
    header: TableContentProperty;
    headerKey: UniqueHeaderKey;
    item: TableContentItem;
    headerIndex: number;
    accumulationTableContentWidth: number;
    isVariableWidth: boolean;
    isAllSelected: boolean;
    stableColumnCount: number;
    isBold: boolean;
    isChecked: boolean;
    isCheckedBusinessId: boolean;
  }>(),
  {}
);

// emits
const emits = defineEmits<{
  (e: 'onClickNarrow'): void;
}>();

const uniqueTableContentVM = new UniqueTableContentViewModel();

const textAlign = computed(() => {
  return props.header.propertyPath?.propertyType === 'number' ? 'right' : 'left';
});
</script>

<template>
  <TableCell
    :class="[uniqueTableContentVM.isSticky(stableColumnCount, headerIndex) ? 'sticky-content' : '']"
    :style="{
      left: uniqueTableContentVM.calcStickyDiff(stableColumnCount, headerIndex, accumulationTableContentWidth),
      opacity: 0,
    }"
    class="table-cell base-table__body--fixed"
    :text-align="textAlign"
    :table-content-property="header"
    :tool-tip-value="uniqueTableContentVM.displayUniqueItem(headerKey, item)"
    :is-highlighted="props.isChecked || props.isCheckedBusinessId"
  >
    <span class="table-cell-content" :class="{ 'table-cell-content': isBold }" @click="emits('onClickNarrow')">
      {{ uniqueTableContentVM.displayUniqueItem(headerKey, item) }}
    </span>
  </TableCell>
</template>

<style scoped lang="scss">
.table-cell-content {
  font-family: Noto Sans JP;
  font-size: $fontSizeSS;
  font-weight: 400;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  &--bold {
    font-weight: bold;
  }
}
</style>
